
import { Component, OnInit, } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { API_ENDPOINTS } from '../../../../shared/utils/const';
import { ApiService } from '../../../../shared/services/api.service';
import { data } from 'jquery';
import { ToastrService } from 'ngx-toastr';
import { interval, Subject, takeUntil } from 'rxjs';
import { CryptoService } from '../../../../shared/services/crypto.service';
import { CommonService } from '../../../../shared/services/common.service';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrl: './forgotpassword.component.css'
})
export class ForgotpasswordComponent {

  isSigninas: boolean = true;
  signinas: string = 'MSME'; // Default selection
  usernamePrefix: string = 'UDYAM-MH-';

  mobilenum: string = '';
  email: string = '';
  isDisabled: boolean = true;
  showNewPassword: boolean = false;
  showConfirmNewPassword: boolean = false;
  isPasswordValid: boolean = false;
  //form: FormGroup;
  isMobResendButtonDisabled: boolean = true;

  mobileOtpTimer = 300; // 5 minutes (300 seconds)

  maxResendAttempts: number = 5;
  emailOtpTimer: number = 60;
  //mobileOtpTimer: number = 60; 
  
  emailOtpTimerRunning: boolean = false;
  mobileOtpTimerRunning: boolean = false;
  countdown: number = 60;
  countdownDisplay: string | undefined;
  isResendButtonDisabled: boolean = true;
  
  countdownSubject: Subject<void> = new Subject<void>();

  mobileSpocOtpTimerRunning: boolean = false;
  mobileSpocOtpTimer: number = 60;

  mobileResendCount = 1;
  emailResendCount = 1;


  isButtonDisabled: boolean = false;
  isButtonEmailDisabled: boolean = false;
  isButtonMobileDisabled: boolean = false;
  isVerifyButtonDisabled: boolean = false;

  emailOtpSent: boolean = false;
  mobileOtpSent: boolean = false;
  resendEmailOtpDisabled: boolean = true;
  resendMobileOtpDisabled: boolean = true;


  isVerifyEmailOtpButtonDisabled: boolean = true;
  isVerifyMobileOtpButtonDisabled: boolean = true;
  emailotpError: boolean = false;
  emailotpSuccess: boolean = false;
  otpError: boolean = false;
  otpSuccess: boolean = false;

  //countdownSubject = new Subject<void>();


  form = new FormGroup({
    signinas: new FormControl('MSME', [Validators.required]),
    username: new FormControl('', [Validators.required, Validators.maxLength(19)]),
    newpassword: new FormControl('', [Validators.required, Validators.minLength(8), Validators.pattern(this.commonService.passwordPattern)]),
    confirmpassword: new FormControl('', [Validators.required]),
    mobotp: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6), Validators.pattern('^[0-9]{6}$')]),
    resendbtn:new FormControl(''),
  },
    { validators: this.passwordsMatchValidator } 
  );


  constructor(
    private router: Router,
    private apiService: ApiService,
    private toastrService: ToastrService,
    private cryptoService: CryptoService,
    private commonService: CommonService,
    
  ) { }


  //this.isPasswordValid = !this.form.errors?.passwordMismatch;

  onSignInAsChange(event: any): void {
    this.signinas = event.target.value;

    // Reset the form while preserving 'signinas' value
    this.form.reset();

    this.form.patchValue({ signinas: this.signinas });

    const usernameControl = this.form.get('username');

    if (this.signinas === 'MSME') {
      this.usernamePrefix = 'UDYAM-MH-';
      usernameControl?.setValidators([
        Validators.required,
        Validators.pattern(this.commonService.udyamNumber), // UDYAM format validation
        Validators.maxLength(19) // Max length for UDYAM MSME
      ]);
    } else {
      this.usernamePrefix = ''; // No prefix for email
      usernameControl?.setValidators([
        Validators.required,
        Validators.email, // Email validation
        Validators.maxLength(50) // Max length for Email ID
      ]);
    }

    // Set initial value with prefix (if applicable) and update validity
    this.form.patchValue({ username: this.usernamePrefix });
    usernameControl?.updateValueAndValidity();

    
    this.isButtonMobileDisabled = false;  
    this.resendMobileOtpDisabled = true;  
    this.mobileOtpTimerRunning = false;   
    this.mobileOtpTimer = 0;
    this.form.controls.resendbtn.disable()
  }

  
  

  ngOnInit(): void {
    this.form.patchValue({ username: this.usernamePrefix });
    this.form.statusChanges.subscribe(() => {
      if (this.form.valid) {
        this.isDisabled = false;
      }
      else {
        this.isDisabled = true;
      }
      const usernameValue = this.form.controls.username?.value; // Assuming 'username' is the control name
      const newPasswordValue = this.form.controls.newpassword?.value;
      const confirmPasswordValue = this.form.controls.confirmpassword?.value;

      const usernameValid = this.form.controls.username?.valid && usernameValue?.trim() !== '';
      const newPasswordValid = this.form.controls.newpassword?.valid && newPasswordValue?.trim() !== '';
      const confirmPasswordValid = this.form.controls.confirmpassword?.valid && confirmPasswordValue?.trim() !== '';

      if (usernameValid) {// && newPasswordValid && confirmPasswordValid && newPasswordValue === confirmPasswordValue) {
        this.isPasswordValid = true;
        this.form.controls.newpassword
      } else {
        this.isPasswordValid = false;
      }

      this.form.get('mobotp')?.valueChanges.subscribe(() => {
        this.toggleVerifyButtons();
      });
      
      
    });
    this.updateUsernameValidation();
    this.form.controls.newpassword.disable();
    this.form.controls.confirmpassword.disable();
  }

  private updateUsernameValidation(): void {
    const usernameControl = this.form.get('username');

    if (this.signinas === 'MSME') {
      usernameControl?.setValidators([
        Validators.required,
        Validators.pattern(this.commonService.udyamNumber),
        Validators.maxLength(19) 
      ]);
    } else {
      usernameControl?.setValidators([
        Validators.required,
        Validators.email, 
        Validators.maxLength(50) 
      ]);
    }

    usernameControl?.updateValueAndValidity();
  }

  passwordsMatchValidator(control: AbstractControl): ValidationErrors | null {
    const password = control.get('newpassword')?.value;
    const confirmPassword = control.get('confirmpassword')?.value;

    if (password && confirmPassword && password !== confirmPassword) {
      control.get('confirmpassword')?.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    } else {
      control.get('confirmpassword')?.setErrors(null);
      return null;
    }
  }


  toggleShowNewPassword() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleShowConfirmNewPassword() {
    this.showConfirmNewPassword = !this.showConfirmNewPassword;
  }

  onPaste(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
    this.toastrService.show('Pasting is disabled in the Confirm Password field for security reasons.');
  }

  get f() { return this.form.controls }

  async generateOTP(form: any) {
    try {
      if (!this.form.controls.username.value || this.form.controls.username.invalid) {
        this.toastrService.error("Please enter a valid Username");
        return;
      }      

      switch (form.controls.signinas.value) {
        case "MSME":
          const msmError = this.LoadMSMEDetails();
          
          //if (msmError) {
          //  return;
          //}
          //await this.SendOTP();
          break;


        case "IA":
          const iaError = this.LoadIADetails();
          
          //if (iaError) {
          //  return;
          //}
          //await this.SendOTP();
          break;

        default:
          this.toastrService.error("Invalid selection.");
          break;
      }
    } catch (error) {
      console.error('Error in generatedOTP', error);
    }
  }

  LoadMSMEDetails() {

    const data = {
      udyamNumber: this.form.controls.username.value?.toString(),
    }

    //var UdyamNumber = 'UDYAM-MH-15-9519910';
    this.apiService.postRequest(API_ENDPOINTS.MSME.GETMSMECONTACTDETAILS, data).subscribe(
      (result) => {
        if (result.status) {
          this.toastrService.success('OTP Sent Successfully');
          //this.toastrService.success(result.message);
          this.email = result.data.email;
          this.mobilenum = result.data.ownersMobileNumber;
          this.startMobileOtpTimer();
          return false;
        } else {
          this.toastrService.error("Failed to retrieve user details. Please try again.");
          return true;
        }
      });
  }

   LoadIADetails() {
    
      const data = {
        iAUserName: this.form.controls.username.value?.toString(),
      }
      
      this.apiService.postRequest(API_ENDPOINTS.IA.GETCONTACTDETAILS, data).subscribe(
        (result) => {
          if (result.status) {
            this.toastrService.success('OTP Sent Successfully');
            //this.toastrService.success(result.message);
            this.email = result.data.email;
            this.mobilenum = result.data.ownersMobileNumber;
            this.startMobileOtpTimer();
            return false;
          } else {
            this.toastrService.error("Failed to retrieve user details. Please try again.");
            return true;
          }                  
    });
}
 

  resetCountdown() {
    this.stopCountdown();
    this.startResendCountdown();
  }
  

  startMobileOtpTimer() {
    if (this.mobileOtpSent && this.mobileOtpTimerRunning) {
      return; // Prevent sending OTP again while timer is running
    }

    this.mobileOtpSent = true; // Mark that OTP has been sent
    this.mobileOtpTimerRunning = true;
    this.mobileOtpTimer = 300;
    this.isButtonMobileDisabled = true;
    this.resendMobileOtpDisabled = true;

    const mobileTimer = setInterval(() => {
      if (this.mobileOtpTimer > 0) {
        this.mobileOtpTimer--;
      } else {
        clearInterval(mobileTimer);
        this.mobileOtpTimerRunning = false;
        this.resendMobileOtpDisabled = false; // Enable Resend OTP only after timeout
        this.mobileOtpSent = false; // Allow resending OTP
      }
    }, 1000);
  }


  //stopMobileOtpTimer() {
  //  this.mobileOtpTimerRunning = false;
  //  this.resendMobileOtpDisabled = false; // Enable resend button
  //  this.countdownSubject.next(); // Stop timer
  //}
  stopMobileOtpTimer() {
    this.mobileOtpTimerRunning = false;
    // ✅ Do not re-enable the Resend OTP button after OTP verification
    if (!this.otpSuccess) {
      this.resendMobileOtpDisabled = false;
    }
    this.countdownSubject.next();
  }

  startResendCountdown() {
    this.isResendButtonDisabled = true;
    this.countdown = 60;
    interval(1000).pipe(takeUntil(this.countdownSubject)).subscribe(() => {
      if (this.countdown > 0) {
        this.countdown--;
        this.updateCountdownDisplay();
      } else {
        this.stopCountdown();
      }
    });
  }

  stopCountdown() {
    this.countdown = 0;
    this.isResendButtonDisabled = true;
    this.countdownSubject.complete();
  }

  stopMobCountdown() {
    this.countdownSubject.next();
    this.isMobResendButtonDisabled = false;
    this.countdownDisplay = '';
  }

  toggleVerifyButtons() {
    this.isVerifyMobileOtpButtonDisabled = this.form.get('mobotp')?.value?.length !== 6;

  }

  goto(form: any) {
    if (!this.otpSuccess || !this.emailotpSuccess) {
      this.toastrService.error("Please verify OTP");
      return;
    }
    
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }


  updateCountdownDisplay() {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;
    this.countdownDisplay = `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  VerifyOTP() {
    if (!this.form.controls.username.value || this.form.controls.username.value.trim() === '') {
      this.toastrService.error("Please enter a valid username.");
      return;
    }

    let otpdata: any;
    let apiEndpoint: string;

    if (this.form.controls.signinas.value == "MSME") {
      otpdata = {
        MsMeUserName: this.form.controls.username.value,
        OtpType: 'Email',
        OtpValue: this.email,
        Otp: this.form.controls.mobotp.value
      };
      apiEndpoint = API_ENDPOINTS.Otp.MSMEVerifyOtp;
    }
    else if (this.form.controls.signinas.value == "IA") {
      otpdata = {
        IAUserName: this.form.controls.username.value,
        OtpType: 'Email',
        OtpValue: this.email,
        Otp: this.form.controls.mobotp.value
      };
      apiEndpoint = API_ENDPOINTS.Otp.IAVerifyOtp;
    }
    else {
      this.toastrService.error("Invalid Sign-in type.");
      return;
    }

    this.apiService.postRequest(apiEndpoint, otpdata).subscribe(
      (res) => {
        if (res.message === "OTP verified successfully.") {
          this.toastrService.success(res.message);
          this.otpError = false;
          this.otpSuccess = true;
          this.resendMobileOtpDisabled = true;
          this.form.controls.mobotp.setValue('');
          this.isVerifyMobileOtpButtonDisabled = true; 
          this.stopMobileOtpTimer();
          
          this.form.controls.newpassword.enable();
          this.form.controls.confirmpassword.enable();
          this.form.controls.mobotp.disable();
        }
        else {
          this.toastrService.error(res.message || "OTP verification failed.");
          this.otpError = true;
          this.otpSuccess = false;
          this.form.controls.mobotp.setValue('');
          this.isVerifyMobileOtpButtonDisabled = false;
          
          this.form.controls.newpassword.disable();
          this.form.controls.confirmpassword.disable();
          this.form.controls.mobotp.enable();
        }
      },
      (error) => {        
        this.otpError = true;
        this.otpSuccess = false;
        this.form.controls.mobotp.setValue('');
        this.isVerifyMobileOtpButtonDisabled = false; 
                
        this.form.controls.newpassword.disable();
        this.form.controls.confirmpassword.disable();
        this.form.controls.mobotp.enable();
      }
    );
  }



  //  if (this.form.controls.username.value != null && this.form.controls.username.value.trim() !== '')
  //  {
  //    if (this.form.controls.signinas.value == "MSME") {
  //      const otpdata = {
  //        MsMeUserName: this.form.controls.username.value,
  //        OtpType: 'Email',
  //        OtpValue: this.email,
  //        Otp: this.form.controls.mobotp.value
  //      };

  //      const res = await this.apiService.postRequest(API_ENDPOINTS.Otp.MSMEVerifyOtp, otpdata).subscribe(
  //        (res) => {
  //          if (res.status) {
  //            this.toastrService.success(res.message);
  //            this.otpError = false;
  //            this.otpSuccess = true;
  //            this.resendMobileOtpDisabled = true;
  //            this.form.controls.newpassword.enable;
  //            this.form.controls.confirmpassword.enable;
  //            this.form.controls.mobotp.disable;
  //            this.isVerifyMobileOtpButtonDisabled = true;

  //            // ✅ Enable password fields after successful OTP verification
  //            this.form.controls.newpassword.enable();
  //            this.form.controls.confirmpassword.enable();
  //            this.form.controls.mobotp.disable(); // Disable OTP field after successful verification


  //            this.stopMobileOtpTimer();
  //            this.resendMobileOtpDisabled = true;
  //          }
  //          else {
  //            this.otpError = true;
  //            this.otpSuccess = false;
  //            this.form.controls.newpassword.disable;
  //            this.form.controls.confirmpassword.disable;
  //            this.form.controls.mobotp.enable;
  //            this.isVerifyMobileOtpButtonDisabled = false;

  //            // ❌ Disable password fields on failure
  //            this.form.controls.newpassword.disable();
  //            this.form.controls.confirmpassword.disable();
  //            this.form.controls.mobotp.enable();

  //          }
  //        },
  //        //(error) => {
  //        //  console.error('Error during mobile OTP verification:', error);
  //        //  this.toastrService.error("Entered Mobile OTP is incorrect. Please enter correct OTP");
  //        //  this.otpError = true;
  //        //  this.otpSuccess = false;
  //        //}
  //      );
  //    }
  //    else if (this.form.controls.signinas.value == "IA") {


  //      const otpdata = {
  //        IAUserName: this.form.controls.username.value,
  //        OtpType: 'Email',
  //        OtpValue: this.email,
  //        Otp: this.form.controls.mobotp.value
  //      };

  //      const res = await this.apiService.postRequest(API_ENDPOINTS.Otp.IAVerifyOtp, otpdata).subscribe(
  //        (res) => {
  //          if (res.status) {
  //            this.toastrService.success(res.message);
  //            this.otpError = false;
  //            this.otpSuccess = true;
  //            this.resendMobileOtpDisabled = true;
  //            this.form.controls.newpassword.enable;
  //            this.form.controls.confirmpassword.enable;
  //            this.form.controls.mobotp.disable;
  //            this.isVerifyMobileOtpButtonDisabled = true;

  //            // ✅ Enable password fields after successful OTP verification
  //            this.form.controls.newpassword.enable();
  //            this.form.controls.confirmpassword.enable();
  //            this.form.controls.mobotp.disable(); // Disable OTP field after successful verification

  //            this.stopMobileOtpTimer();
  //            this.resendMobileOtpDisabled = true;
              
  //          }
  //          else {
  //            this.otpError = true;
  //            this.otpSuccess = false;
  //            this.form.controls.newpassword.disable;
  //            this.form.controls.confirmpassword.disable;
  //            this.form.controls.mobotp.enable;
  //            this.isVerifyMobileOtpButtonDisabled = false;

  //            // ❌ Disable password fields on failure
  //            this.form.controls.newpassword.disable();
  //            this.form.controls.confirmpassword.disable();
  //            this.form.controls.mobotp.enable();
  //          }
  //        },
  //        (error) => {
  //          //console.error('Error during mobile OTP verification:', error);
  //          //this.toastrService.error("Entered Mobile OTP is incorrect. Please enter correct OTP");
  //          //this.otpError = true;
  //          //this.otpSuccess = false;
  //        }
  //      );
  //    }
  //  }
  //  else  {
  //    this.toastrService.error("Please enter UserName");
  //  }
  //}
  
  //async VerifyOTP() {
  //  if (this.form.controls.username.value && this.form.controls.username.value.trim() !== '') {
  //    let otpdata: any;
  //    let apiEndpoint: string;

  //    if (this.form.controls.signinas.value == "MSME") {
  //      otpdata = {
  //        MsMeUserName: this.form.controls.username.value,
  //        OtpType: 'Email',
  //        OtpValue: this.email,
  //        Otp: this.form.controls.mobotp.value
  //      };
  //      apiEndpoint = API_ENDPOINTS.Otp.MSMEVerifyOtp;
  //    }
  //    else if (this.form.controls.signinas.value == "IA") {
  //      otpdata = {
  //        IAUserName: this.form.controls.username.value,
  //        OtpType: 'Email',
  //        OtpValue: this.email,
  //        Otp: this.form.controls.mobotp.value
  //      };
  //      apiEndpoint = API_ENDPOINTS.Otp.IAVerifyOtp;
  //    }
  //    else {
  //      return this.toastrService.error("Invalid Sign-in type.");
  //    }

  //    this.apiService.postRequest(apiEndpoint, otpdata).subscribe(
  //      (res) => {
  //        if (res.status) {
  //          this.toastrService.success(res.message);
  //          this.otpError = false;
  //          this.otpSuccess = true;
  //          this.resendMobileOtpDisabled = true;
  //          this.isVerifyMobileOtpButtonDisabled = true;
  //          this.stopMobileOtpTimer();

  //          // ✅ Enable password fields after successful OTP verification
  //          this.form.controls.newpassword.enable();
  //          this.form.controls.confirmpassword.enable();
  //          this.form.controls.mobotp.disable(); // Disable OTP field after successful verification
  //        }
  //        else {
  //          this.toastrService.error(res.message || "OTP verification failed.");
  //          this.otpError = true;
  //          this.otpSuccess = false;
  //          this.isVerifyMobileOtpButtonDisabled = false;

  //          // ❌ Disable password fields on failure
  //          this.form.controls.newpassword.disable();
  //          this.form.controls.confirmpassword.disable();
  //          this.form.controls.mobotp.enable();
  //        }
  //      },
  //      (error) => {
  //        this.toastrService.error("Entered Mobile OTP is incorrect. Please enter the correct OTP.");
  //        this.otpError = true;
  //        this.otpSuccess = false;

  //        // ❌ Disable password fields on API error
  //        this.form.controls.newpassword.disable();
  //        this.form.controls.confirmpassword.disable();
  //        this.form.controls.mobotp.enable();
  //      }
  //    );
  //  }
  //  else {
  //    this.toastrService.error("Please enter a valid username.");
  //  }
  //}


  async UpdatePassword(form: any) {
    if (form.invalid) {
      this.toastrService.error("Data is missing...");
      return;
    }
    //const otpVerified = await this.VerifyOTP();

    //if (!this.otpSuccess) {
    //  alert("Please verify OTP");
    //  return;
    //}

    const { signinas, username, newpassword } = this.form.value;

    if (!signinas || !username || !newpassword) {
      this.toastrService.error("All fields are required.");
      return;
    }

    const encryptedEmail = this.cryptoService.encryptnew(this.email);
    const encryptedUsername = this.cryptoService.encryptnew(username);
    const encryptedPassword = this.cryptoService.encryptnew(newpassword);

    switch (form.controls.signinas.value) {
      case "MSME":
        const msmePasswordData = {
          Email: encryptedEmail,
          MsMeUserName: encryptedUsername,
          NewPassword: encryptedPassword
        };
        
        await this.apiService.postRequest(API_ENDPOINTS.FORGOTPASSWORD.MSME, msmePasswordData).subscribe(res => {
          if (res.status) {
            this.toastrService.success("Password updated successfully!");
            this.router.navigateByUrl("/login");
          }
        })
        break;

      case "IA":
        const iaPasswordData = {
          Email: encryptedEmail,
          IAUserName: encryptedUsername,
          NewPassword: encryptedPassword
        };
        this.apiService.postRequest(API_ENDPOINTS.IA.FORGOTPASSWORD, iaPasswordData).subscribe(res => {
          if (res.status) {
            this.toastrService.success("Password updated successfully!");
            this.router.navigateByUrl("/login");
          }
        })
        break;

      // case "MSSIDC":
      //   this.router.navigateByUrl(""); // Handle MSSIDC case
      //   break;

      // case "DIC":
      //   this.router.navigateByUrl(""); // Handle DIC case
      //   break;

      default:
        this.toastrService.error("Invalid selection.");
        break;
    }
  }


  resetForm() { }
}
